export const easySwitch = (valueToCheck, handlers) => handlers[valueToCheck]();



// WEBPACK FOOTER //
// ./src/sc/helpers/switch.js